// Route configuration with preload functions for hover-based prefetching

export const routePreloaders = {
  index: () => import("../pages/Index"),
  breeders: () => import("../pages/Breeders"),
  breederProfile: () => import("../pages/BreederProfile"),
  aiExpert: () => import("../pages/AIExpert"),
  community: () => import("../pages/Community"),
  articles: () => import("../pages/Articles"),
  breeds: () => import("../pages/Breeds"),
  breedQuiz: () => import("../pages/BreedQuiz"),
  calculators: () => import("../pages/Calculators"),
  auth: () => import("../pages/Auth"),
  dashboard: () => import("../pages/Dashboard"),
  breederAuth: () => import("../pages/BreederAuth"),
  breederOnboarding: () => import("../pages/BreederOnboarding"),
  forum: () => import("../pages/Forum"),
  qa: () => import("../pages/QA"),
  stories: () => import("../pages/Stories"),
  events: () => import("../pages/Events"),
  websiteBuilder: () => import("../pages/WebsiteBuilder"),
  analytics: () => import("../pages/Analytics"),
  petTracker: () => import("../pages/PetTracker"),
  premium: () => import("../pages/Premium"),
  messages: () => import("../pages/Messages"),
  websitePreview: () => import("../pages/WebsitePreview"),
  notFound: () => import("../pages/NotFound"),
};

// Most visited pages to prefetch after initial load
export const mostVisitedRoutes = [
  routePreloaders.dashboard,
  routePreloaders.breeders,
  routePreloaders.websiteBuilder,
];

// Prefetch most visited routes in the background after initial page load
export const prefetchMostVisitedRoutes = () => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      mostVisitedRoutes.forEach(preloadFn => {
        preloadFn().catch(err => console.error('Failed to prefetch route:', err));
      });
    });
  } else {
    // Fallback for browsers without requestIdleCallback
    setTimeout(() => {
      mostVisitedRoutes.forEach(preloadFn => {
        preloadFn().catch(err => console.error('Failed to prefetch route:', err));
      });
    }, 2000);
  }
};
